export const shortName = (
  fullName: string,
  isLong?: boolean,
  maxSymbolsLengthWithDots?: number
): string => {
  const manyDots = 3;

  const _maxSymbolsLengthWithDots = maxSymbolsLengthWithDots || 14;
  const maxSymbolsLengthWithoutDots = _maxSymbolsLengthWithDots + manyDots;

  const longMaxSymbolsLengthWithDots = 37;
  const longMaxSymbolsLengthWithoutDots =
    longMaxSymbolsLengthWithDots + manyDots;

  if (isLong) {
    if (fullName.length <= longMaxSymbolsLengthWithoutDots) {
      return fullName;
    } else {
      return `${fullName
        .split('')
        .slice(0, longMaxSymbolsLengthWithDots)
        .join('')}...`;
    }
  } else {
    if (fullName.length <= maxSymbolsLengthWithoutDots) {
      return fullName;
    } else {
      return `${fullName
        .split('')
        .slice(0, maxSymbolsLengthWithDots)
        .join('')}...`;
    }
  }
};
